import { lazy } from 'react';

// ----------------------------------------------------------------------

const InvoicingPage = lazy(() => import('../pages/Invoicing.page'));
const AddInvoicePage = lazy(() => import('../pages/AddInvoice.page'));
const ReturnsPage = lazy(() => import('../pages/Returns.page'));
const CreateReturnRequestPage = lazy(() => import('../pages/CreateReturnRequest.page'));
const CreditorsPage = lazy(() => import('../pages/Creditors.page'));
const StorePermissionsPage = lazy(() => import('../pages/StorePermissions.page'));

// ----------------------------------------------------------------------

const InvoicingRoutes = [
    {
        path: '/invoicing',
        children: [
            { element: <InvoicingPage />, layout: 'default', isAuthReq: true, index: true },
            { path: 'add-invoice', element: <AddInvoicePage />, layout: 'default', isAuthReq: true },
            { path: 'returns', element: <ReturnsPage />, layout: 'default', isAuthReq: true },
            { path: 'create-return-request', element: <CreateReturnRequestPage />, layout: 'default', isAuthReq: true },
            { path: 'creditors', element: <CreditorsPage />, layout: 'default', isAuthReq: true },
            { path: 'store-permissions', element: <StorePermissionsPage />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { InvoicingRoutes };
